import React from 'react';
import Button from 'components/Button/Button';
import Text from 'components/Text';

const LegalMentions = (t) => (
  <>
    <Button appearance="simple" as="a" href="/static/doc/mentions-legales-onevision.pdf" download>
      <Text size="p2" className="footer__link">
        {t('footer-legal-notices')}
      </Text>
    </Button>
    <span className="footer__separator" />
  </>
);

export default LegalMentions;
